import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    api_responses: {},
    needs_reload: false
  },
  getters: {
    get: state => name => {
      return state.api_responses[name] &&
        moment().isBefore(state.api_responses[name].expires_at)
        ? state.api_responses[name].value
        : false;
    },
    refresh: state => state.needs_reload
  },
  mutations: {
    set: (state, payload) => {
      Vue.set(state.api_responses, payload.name, {
        value: payload.value,
        expires_at: payload.expires_at
      });
    },
    clear: state => {
      Vue.set(state, "api_responses", {});
      state.needs_reload = false;
    },
    refresh: state => {
      state.needs_reload = true;
    }
  },
  actions: {
    fetch(context, payload) {
      if (context.getters.get(payload.name)) return;

      context.commit(
        "set",
        Object.assign(payload, {
          value: true,
          expires_at: moment().add(5, "s") // very short while other components are initializing
        })
      );

      payload.function((error, data, response) => {
        if (!error) {
          context.commit(
            "set",
            Object.assign(payload, {
              value: data,
              expires_at: moment().add(5, "m")
            })
          );
        }
      });
    }
  }
});

export default store;
